import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import ContactForm from "../components/ContactForm";
import ClinicForms from "../components/ClinicForms.jsx";
import { Helmet } from "react-helmet-async";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Greenwich Clinic Pharmacy</title>
        <meta
          name="description"
          content="Welcome to Greenwich Clinic & Pharmacy - Your trusted partner for health and wellness. We offer a wide range of pharmaceutical services and products to meet your healthcare needs."
        />
        <meta
          name="keywords"
          content="Pharmacy, Greenwich Clinic, Health, Wellness, Medication, Prescription, Over-the-counter, OAT, Compounding, Vaccination & Immunizations"
        />
        <meta
          name="keywords"
          content="Spanish Speaking Physician, Travel Health Services, Blister Packaging, Medication Reviews, Health Consultations, Tele Medicine, Home Delivery, IFHP Services, MinorIllness Treatment"
        />
      </Helmet>
      <Hero />
      <About />
      <ContactForm />
      <ClinicForms />
    </>
  );
}
